import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import CompanyLayout from './CompanyLayout';
import PetOwnerLayout from './PetOwnerLayout';

const LayoutRouter = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  const getLayout = () => {
    const path = location.pathname;

    // ВАЖНО: Если путь начинается с /admin, мы возвращаем Fragment (<>).
    // Это потому, что в App.js мы УЖЕ обернули эти роуты в AdminLayout.
    if (path.startsWith('/admin')) {
      return React.Fragment;
    }

    // То же самое для /company, если ты решишь перевести его на структуру вложенных роутов
    if (path.startsWith('/company')) {
      return CompanyLayout;
    }

    // Auth pages
    if (path.startsWith('/login') || path.startsWith('/register') || path.startsWith('/forgot-password') || path.startsWith('/reset-password')) {
      return PetOwnerLayout;
    }

    return PetOwnerLayout;
  };

  const Layout = getLayout();

  // Если это Fragment, он просто отрендерит children без лишних оберток
  return (
    <Layout>
      {children}
    </Layout>
  );
};

export default LayoutRouter;